import styled from "styled-components";

export const NavBarWrapper = styled.div`
  height: 65px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 15px;
`;

export const NavBarMenuIconWrapper = styled.div`
  display: flex;
  height: 100%;
  align-items: center;
`;

export const NavBarMenuWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 61px;
  height: 100%;
  border-right: 1px solid #e3e8ed;
`;

export const NavBarMenu = styled.img`
  cursor: pointer;
`;

export const NavBarLogo = styled.img`
  width: 85px;
  height: 15px;
  padding-left: 20px;
`;

export const NavBarMenuTextWrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap:20px;
`;

export const NavBarMenuText = styled.div`
    font-size:16px;
    font-weight: 400;
`

export const NavBarCartContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  height: 35px;
  width: 50px;
  border: 1px solid #e3e8ed;
  border-radius: 32px;
  cursor: pointer;
`;

export const NavBarCartLogo = styled.img``;
